module.exports = __webpack_public_path__ + "static/img/employee-05-big.3b406e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/community/employee-05-big.png
// module id = S2k3
// module chunks = 2